export default class PreventFormDataLoss {

    constructor(formSelector) {
        const formEl = $(formSelector);
        if (!formEl) {
            throw new Error("Unable to create instance for PreventFormDataLoss. formSelector value passed: " + formSelector);
        }

        this.formEle = formEl;

        this.initialFormState = formEl.serialize();
        this.formSubmitting = false;
        this.alreadyConfirmed = false;

        this.listenForFormSubmit();
        this.listenForPageLeave();
    }

    pause() {
        this.alreadyConfirmed = true;
    }

    resetInitialState() {
        this.initialFormState = this.formEle.serialize();
    }

    listenForPageLeave() {
        $(window).bind('beforeunload', evt => {
            const currentState = this.formEle.serialize();
            if (this.initialFormState !== currentState && !this.formSubmitting && !this.alreadyConfirmed) {
                return true;
            }
        });
    }

    listenForFormSubmit() {
        this.formEle.submit(evt => this.formSubmitting = true);
    }
}